exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".header .close-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem; }\n\n.header .back-button {\n  position: absolute;\n  top: 1rem;\n  left: 1rem; }\n\n.header .anticon {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 18px;\n  font-weight: bold;\n  border-radius: 50%;\n  padding: 4px;\n  background: white;\n  box-shadow: 0 6px 12px -5px rgba(0, 0, 0, 0.24); }\n\n.header .anticon:hover {\n  color: #444; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/MenuUser/Header/Header.scss
// module id = 1437
// module chunks = 0